<template>
    <div v-if="warningZone">
    <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">              
                <div class="modal-body">
                    <slot name="body">
                    <p v-if="languageData['timeout']" v-html="languageData['timeout']"></p>
                    <p v-else >Your session on this site is about to be discontinued due to inactivity. Please click “Continue” if you would like to remain on the site.</p>
                    <p>
                        <button v-if="languageData['Continue']" class="modal-default-button" @click="warningZone=false" v-html="languageData['Continue']"></button>
                        <button v-else class="modal-default-button" @click="warningZone=false" >Continue</button>
                        <button v-if="languageData['logout']" class="modal-default-button" @click="logMeOut" v-html="languageData['logout']"></button>
                        <button v-else class="modal-default-button" @click="logMeOut" >Logout</button>
                    </p>
                    </slot>
                </div>
               <!-- <div class="modal-footer">                
              </div>-->
            </div>
          </div>
        </div>
    </transition>
    </div>   
</template>

<script>
import axios from 'axios';
import { AsgardeoSPAClient } from "@asgardeo/auth-spa";
import {LOCAL_HOST,WSO_CLIENTID,WSO_BASEURL} from '@/constants/general_constants';

const auth = AsgardeoSPAClient.getInstance();
auth.initialize({
     signInRedirectURL: LOCAL_HOST+"/ssowsocallback",
     signOutRedirectURL: LOCAL_HOST+"/ssowsologout",
     clientID: WSO_CLIENTID,
     baseUrl: WSO_BASEURL,
     scope: [ "profile" ]
});

export default {
    name: 'Logout',
    data(){
        return{
            events:['click', 'mousemove', 'mousedown', 'scroll', 'keypress','load'],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            SESSION_TIME:this.$store.state.SESSION_TIME,
         //   languageData:this.$store.state.languageData,
            warningTimer:null,
            logoutTimer:null,
            warningZone:false
        };
        
    },
    computed:{
       languageData(){return this.$store.state.languageData;}       
    },
    mounted :function(){       
      this.events.forEach(function(event) {
          window.addEventListener(event, this.resetTimer);
      },this);        

       this.setTimers();
    },
    destroyed:function(){
        this.events.forEach(function(event) {
          // window.addEventListener(event, this.resetTimer);
       },this);
      // this.resetTimers();
    },
	methods:{
        setTimers: function(){
           if(localStorage.id_session){
                this.warningTimer=setTimeout(this.warningMessage,(this.SESSION_TIME*60*1000));            
                this.warningZone=false;
           }
        },

        warningMessage:function(){
            this.warningZone=true;
        },

        logoutUser:function(){
            //clear cache
        },
        resetTimer:function(){            
          if(this.warningZone==false){
              clearTimeout(this.warningTimer);
              this.setTimers();
          }
        },
        logMeOut:function(){
            this.warningZone=false;
            var filename=localStorage.filename;
            var id_eap=localStorage.id_eap;
            var is_ssouser = localStorage.is_ssouser;
            if (is_ssouser == '1') {
              auth.signOut()
            } else {
            // if(localStorage.id_session){alert(' store')}
              localStorage.removeItem('id_session');
              localStorage.removeItem('id_company');            
              localStorage.clear();
              if(filename!=""){
                  //this.$router.go('/companyLogin/'+id_eap+'/'+filename);
                  window.location.assign('/companyLogin/'+id_eap+'/'+filename);
              }
              else{
                  this.$router.go('/');
              }
            }
        }
    }
};
</script>
<style scoped>
/* for modal */
.modal-mask {
  position: fixed;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  width:50%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-body {
  margin: 20px 0;
  padding: 0 !important;
}
.modal-default-button {
    margin-right: 15px !important;
    border-width: 1px !important;
    border-radius: 5px !important;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>